import { Quill } from "react-quill-new"

// QuillからDeltaクラスを取得
const Delta = Quill.import("delta")

// 画像のコピー&ペーストを制限するclipboard matchers
// テキストのペーストやHTML書式（太字、斜体、リンクなど）は保持される
export const restrictImagePasteMatchers = [
  ["img", () => {
    // クリップボードから貼り付けられた画像を無視する
    // 画像管理機能（handleImageInsert）経由の画像挿入は影響を受けない
    return new Delta()  // 空のDeltaを返すことで画像ノードを無視
  }]
]
